import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DelayFailureTemplatesComponent } from './delay-failure-templates.component';

const routes: Routes = [
  {
    path: '',
    component: DelayFailureTemplatesComponent,
    data: { title: 'Delay Failure Templates' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DelayFailureTemplatesRoutingModule {}

@NgModule({
  imports: [
    DelayFailureTemplatesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [DelayFailureTemplatesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [DelayFailureTemplatesComponent],
})
export class DelayFailureTemplatesModule {}
